export default __webpack_public_path__ + "static/media/smallbottle.43237aad.svg";